import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const initApp = () => {
  const root = document.getElementById('inruil-start-app');

  if (root && root.dataset) {
    const { api } = root.dataset;
    if (!api) throw new Error('Api is required in the inruil start app container');

    const {
      hexonkenteken,
      hexonmerk,
      hexonmodel,
      hexonuitvoering,
      hexonbrandstof,
      hexonisnieuw,
      hexonlefid,
      hexonisvkv,
      hexonvoertuignummer,
      hexonklantnummer,
      hexonverkoopprijs
    } = root.dataset;

    ReactDOM.render(<App
      api={api}
      hexonkenteken={hexonkenteken}
      hexonmerk={hexonmerk}
      hexonmodel={hexonmodel}
      hexonuitvoering={hexonuitvoering}
      hexonbrandstof={hexonbrandstof}
      hexonisnieuw={hexonisnieuw}
      hexonlefid={hexonlefid}
      hexonisvkv={hexonisvkv}
      hexonvoertuignummer={hexonvoertuignummer}
      hexonklantnummer={hexonklantnummer}
      hexonverkoopprijs={hexonverkoopprijs}
    />, root);
  }
}

// see if DOM is already available
if (document.readyState === "complete" || document.readyState === "interactive") {
  // call on next available tick
  initApp();
} else {
  document.addEventListener("DOMContentLoaded", initApp);
}